import coding from '../assets/image1.svg'
import creation from '../assets/creation.svg'
import profile from '../assets/pic.png'
import dots from '../assets/pattern.svg'
import oyola from '../assets/oyola.png'

export default{
    coding,
    creation,
    profile,
    dots,
    oyola,
}